/* PROMOÇÃO PROGRESSIVA CALEO V2 */
(function () {
  if (window.__caleoProgressiveDiscountV2Loaded) {
    if (window.caleoProgressiveDiscount && window.caleoProgressiveDiscount.refreshAll) window.caleoProgressiveDiscount.refreshAll();
    return;
  }
  window.__caleoProgressiveDiscountV2Loaded = true;

  var baseCartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url)
    || (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url)
    || '/cart';
  var CART_URL = /\.js(?:\?|$)/.test(baseCartUrl) ? baseCartUrl : baseCartUrl + '.js';
  var refreshTimer = null;
  var campaignBoundaryTimer = null;
  var latestCart = null;

  function clamp(value, min, max) {
    value = Number(value || 0);
    return Math.max(min, Math.min(max, value));
  }

  function parseBool(value) {
    return value === true || value === 'true' || value === '1';
  }

  /*
   * VEREDITO DO SERVIDOR - trava principal desta correcao.
   *
   * A campanha so pode existir se o Liquid (fuso da loja) tiver dito que ela
   * esta ativa nesta renderizacao. O relogio do aparelho do visitante nunca
   * liga a campanha; ele so pode desliga-la antes da hora.
   *
   * Se a flag nao existir - por exemplo numa pagina antiga restaurada do cache
   * ou do bfcache do navegador - o padrao e INATIVO, e todo residuo visual da
   * promocao e apagado da tela.
   */
  function serverSaysActive() {
    return window.CALEO_CPD_SERVER_ACTIVE === true;
  }

  function parseDate(value) {
    var raw = String(value || '').trim();
    if (!raw) return null;
    if (raw.indexOf(' ') > -1 && raw.indexOf('T') === -1) raw = raw.replace(' ', 'T');
    var offset = raw.match(/([+-])(\d{2}):(\d{2})$/);
    if (offset && (Number(offset[2]) > 14 || Number(offset[3]) > 59)) return null;
    var parsed = new Date(raw);
    if (!isNaN(parsed.getTime())) return parsed;
    var match = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?$/);
    if (!match) return null;
    return new Date(+match[1], +match[2] - 1, +match[3], +match[4], +match[5], +(match[6] || 0));
  }

  function isCampaignActive(root) {
    if (!serverSaysActive()) return false;
    if (!root || !parseBool(root.dataset.enabled)) return false;
    var startRaw = String(root.dataset.start || '').trim();
    var endRaw = String(root.dataset.end || '').trim();
    var start = parseDate(startRaw);
    var end = parseDate(endRaw);
    var now = Date.now();
    if (startRaw && !start) return false;
    if (endRaw && !end) return false;
    if (start && now < start.getTime()) return false;
    if (end && now >= end.getTime()) return false;
    return true;
  }

  function normalize(value) {
    var text = String(value || '').toUpperCase();
    try { text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (error) {}
    return text.replace(/\s+/g, '').trim();
  }

  function getExcludedTitleSet(root) {
    var set = {};
    String((root && root.dataset.excludedTitles) || '').split(/\n|\|/).forEach(function (entry) {
      var key = normalize(entry);
      if (key) set[key] = true;
    });
    return set;
  }

  function getExcludedHandleSet(root) {
    var set = {};
    String((root && root.dataset.excludedHandles) || '').toLowerCase().split('|').forEach(function (entry) {
      var key = String(entry || '').trim().toLowerCase();
      if (key) set[key] = true;
    });
    return set;
  }

  function getSteps(root) {
    try {
      return JSON.parse(root.dataset.steps || '[]').map(function (step) {
        return { qty: Math.max(0, parseInt(step.qty || 0, 10)), discount: clamp(parseFloat(step.discount || 0), 0, 100) };
      }).filter(function (step) { return step.qty > 0; }).sort(function (a, b) { return a.qty - b.qty; });
    } catch (error) {
      return [];
    }
  }

  function isItemExcluded(item, excludedTitles, excludedHandles) {
    return false;
  }

  function getTier(quantity, steps) {
    var current = { qty: 0, discount: 0 };
    steps.forEach(function (step) { if (quantity >= step.qty) current = step; });
    return current;
  }

  function getNextTier(quantity, steps) {
    for (var index = 0; index < steps.length; index += 1) if (quantity < steps[index].qty) return steps[index];
    return null;
  }

  function getStepPosition(step, steps) {
    if (!step || !steps.length) return 0;
    var first = steps[0];
    var last = steps[steps.length - 1];
    var range = last.qty - first.qty;
    return range > 0 ? clamp(((step.qty - first.qty) / range) * 100, 0, 100) : 0;
  }

  function getProgress(quantity, steps) {
    if (!steps.length) return 0;
    var first = steps[0];
    var last = steps[steps.length - 1];
    var range = last.qty - first.qty;
    if (range <= 0 || quantity <= first.qty) return 0;
    return clamp(((quantity - first.qty) / range) * 100, 0, 100);
  }

  function getEligibleData(cart, root) {
    var excludedTitles = getExcludedTitleSet(root);
    var excludedHandles = getExcludedHandleSet(root);
    var steps = getSteps(root);
    var quantity = 0;
    var totalCents = 0;
    ((cart && cart.items) || []).forEach(function (item) {
      if (isItemExcluded(item, excludedTitles, excludedHandles)) return;
      var itemQuantity = Math.max(0, parseInt(item.quantity || 0, 10));
      var lineCents = Number(item.final_line_price);
      if (!Number.isFinite(lineCents)) lineCents = Number(item.line_price);
      if (!Number.isFinite(lineCents)) lineCents = Number(item.original_line_price);
      quantity += itemQuantity;
      totalCents += Math.max(0, Number.isFinite(lineCents) ? lineCents : 0);
    });
    var currentTier = getTier(quantity, steps);
    var lastTier = steps[steps.length - 1] || { qty: 1, discount: 0 };
    return {
      quantity: quantity,
      totalCents: totalCents,
      discount: currentTier.discount || 0,
      discountCents: Math.floor(totalCents * (currentTier.discount || 0) / 100),
      currentTier: currentTier,
      nextTier: getNextTier(quantity, steps),
      lastTier: lastTier,
      steps: steps,
      progress: getProgress(quantity, steps),
      excludedTitles: excludedTitles,
      excludedHandles: excludedHandles
    };
  }

  function formatMoney(cents) {
    cents = Math.max(0, Math.round(Number(cents || 0)));
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      var value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return 'R$ ' + value;
    }
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = !!hidden;
    element.classList.toggle('hidden', !!hidden);
    element.setAttribute('aria-hidden', hidden ? 'true' : 'false');
  }

  function cloneCampaignTemplate(template, target, before) {
    if (!template || !target || !template.content) return null;
    var fragment = template.content.cloneNode(true);
    var root = fragment.querySelector('[data-cpd-version="2"]');
    if (!root) return null;
    target.insertBefore(root, before || null);
    return root;
  }

  function ensureCampaignSurfaces() {
    if (!serverSaysActive()) return;
    var productTemplate = document.querySelector('template[data-cpd-product-template]');
    var productInfo = document.querySelector('#MainContent product-info .product__info-container')
      || document.querySelector('#MainContent .product__info-container');
    if (productInfo) {
      var whatsapp = productInfo.querySelector('.ws-btn-wrap');
      var buyButton = productInfo.querySelector('product-form.product-form') || productInfo.querySelector('.product-form');
      var shippingGoal = productInfo.querySelector('caleo-product-shipping-goal');
      var placementAnchor = shippingGoal || whatsapp || buyButton;
      if (!shippingGoal) {
        while (placementAnchor && placementAnchor.parentElement !== productInfo) placementAnchor = placementAnchor.parentElement;
      }
      var placementParent = placementAnchor && placementAnchor.parentElement
        ? placementAnchor.parentElement
        : productInfo;

      var productRoot = productInfo.querySelector('[data-caleo-progressive-product][data-cpd-version="2"]');
      if (productTemplate && !productRoot) {
        productRoot = cloneCampaignTemplate(productTemplate, placementParent, placementAnchor ? placementAnchor.nextSibling : null);
      }
      if (productRoot && placementAnchor && productRoot.previousElementSibling !== placementAnchor) {
        placementParent.insertBefore(productRoot, placementAnchor.nextSibling);
      }
    }

    var miniTemplate = document.querySelector('template[data-cpd-cart-template="mini"]');
    var miniHeader = document.querySelector('.mini-cart__header');
    if (miniTemplate && miniHeader && !miniHeader.querySelector('[data-caleo-progressive-cart][data-cpd-version="2"][data-cpd-context="mini"]')) {
      var originalBar = miniHeader.querySelector('[data-caleo-progressive-original-cart]');
      cloneCampaignTemplate(miniTemplate, miniHeader, originalBar ? originalBar.nextSibling : null);
    }

    var pageTemplate = document.querySelector('template[data-cpd-cart-template="page"]');
    var pageItems = document.querySelector('cart-items #main-cart-items');
    var cartItems = pageItems && pageItems.closest('cart-items');
    if (pageTemplate && cartItems && !cartItems.querySelector('[data-caleo-progressive-cart][data-cpd-version="2"][data-cpd-context="page"]')) {
      var title = cartItems.querySelector('.title-wrapper');
      cloneCampaignTemplate(pageTemplate, cartItems, title ? title.nextSibling : cartItems.firstChild);
    }
  }

  function renderCartRoot(root, cart) {
    if (!root) return;
    var hasItems = !!(cart && Number(cart.item_count || 0) > 0);
    var active = isCampaignActive(root) && hasItems;
    setHidden(root, !active);
    if (!active) { root.dataset.discountCents = '0'; return; }
    var data = getEligibleData(cart, root);
    root.dataset.eligibleQuantity = String(data.quantity);
    root.dataset.eligibleTotalCents = String(data.totalCents);
    root.dataset.currentDiscount = String(data.discount);
    root.dataset.discountCents = String(data.discountCents);
    root.style.setProperty('--cpd-progress', data.progress.toFixed(2) + '%');

    var badge = root.querySelector('[data-cpd-current-badge]');
    if (badge) badge.textContent = data.discount > 0 ? data.discount + '% OFF ativo' : 'Comece agora';
    var message = root.querySelector('[data-cpd-cart-message]');
    if (message) {
      if (data.quantity >= data.lastTier.qty && data.discount > 0) {
        message.innerHTML = '<strong>' + data.discount + '% OFF ativado.</strong> Você chegou ao maior desconto da campanha.';
      } else if (data.nextTier) {
        var remaining = Math.max(0, data.nextTier.qty - data.quantity);
        var itemLabel = remaining === 1 ? 'item' : 'itens';
        if (data.discount > 0) {
          message.innerHTML = '<strong>' + data.discount + '% OFF ativado.</strong> Adicione mais <strong>' + remaining + '</strong> ' + itemLabel + ' e desbloqueie <strong>' + data.nextTier.discount + '% OFF</strong>.';
        } else {
          message.innerHTML = 'Adicione <strong>' + remaining + '</strong> ' + itemLabel + ' participante' + (remaining === 1 ? '' : 's') + ' e desbloqueie <strong>' + data.nextTier.discount + '% OFF</strong>.';
        }
      }
    }

    root.querySelectorAll('.caleo-progressive-cart__step').forEach(function (element, index) {
      var step = data.steps[index];
      setHidden(element, !step);
      if (!step) return;
      element.classList.toggle('is-active', data.quantity >= step.qty);
      element.style.setProperty('--step-left', getStepPosition(step, data.steps).toFixed(2) + '%');
      var percent = element.querySelector('b');
      var quantity = element.querySelector('small');
      if (percent) percent.textContent = step.discount + '%';
      if (quantity) quantity.textContent = step.qty + (step.qty === 1 ? ' item' : (index === data.steps.length - 1 ? '+ itens' : ' itens'));
    });
  }

  function getActiveCartRoot() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-caleo-progressive-cart][data-cpd-version="2"]'));
    for (var index = 0; index < roots.length; index += 1) if (isCampaignActive(roots[index])) return roots[index];
    return null;
  }

  function getActiveConfigRoot() {
    var cartRoot = getActiveCartRoot();
    if (cartRoot) return cartRoot;
    var products = Array.prototype.slice.call(document.querySelectorAll('[data-caleo-progressive-product][data-cpd-version="2"]'));
    for (var index = 0; index < products.length; index += 1) if (isCampaignActive(products[index])) return products[index];
    var config = document.querySelector('[data-caleo-progressive-config][data-cpd-version="2"]');
    if (config && isCampaignActive(config)) return config;
    return null;
  }

  function getMiniCartAdjustment(cartTotalCents) {
    var root = getActiveCartRoot();
    if (!root || !parseBool(root.dataset.adjustSummary)) {
      return { active: false, discountCents: 0, adjustedProductsCents: Math.max(0, Number(cartTotalCents || 0)), discount: 0 };
    }
    var discountCents = Math.max(0, Number(root.dataset.discountCents || 0));
    return {
      active: true,
      discountCents: discountCents,
      adjustedProductsCents: Math.max(0, Number(cartTotalCents || 0) - discountCents),
      discount: Math.max(0, Number(root.dataset.currentDiscount || 0))
    };
  }

  function getShippingCents(cartTotalCents) {
    if (getActiveConfigRoot()) return 0;
    if (window.CALEO_FREE_SHIPPING_CAMPAIGN_ACTIVE) return 0;
    var threshold = Number(window.CALEO_FREE_SHIPPING_THRESHOLD_CENTS || 0);
    if (threshold > 0 && cartTotalCents >= threshold) return 0;
    try {
      var quote = window.miniCartShippingQuote && window.miniCartShippingQuote.get && window.miniCartShippingQuote.get();
      var price = quote && Number(quote.priceCents);
      if (Number.isFinite(price)) return Math.max(0, price);
    } catch (error) {}
    return 0;
  }

  function ensureDiscountRow(summary) {
    var row = summary.querySelector('[data-caleo-progressive-summary-row]');
    if (row) return row;
    row = document.createElement('div');
    row.className = 'cart-subtotal cart-subtotal--progressive-discount hidden';
    row.hidden = true;
    row.setAttribute('data-caleo-progressive-summary-row', '');
    row.innerHTML = '<span data-caleo-progressive-summary-label>Desconto progressivo</span><span data-caleo-progressive-summary-value></span>';
    var totalRow = summary.querySelector('.cart-subtotal--total');
    if (totalRow) summary.insertBefore(row, totalRow); else summary.appendChild(row);
    return row;
  }

  function updateMiniCartSummary(cart) {
    var summary = document.querySelector('[data-mini-cart-summary]');
    if (!summary) return;

    /*
     * Com a campanha inativa este script nao encosta mais no resumo: os valores
     * impressos pelo Liquid (e mantidos por cart.js) sao os corretos. Antes, ele
     * reescrevia Produtos/Total/PIX/parcela mesmo desligado, usando um total
     * possivelmente velho guardado em data-cart-total-cents - foi assim que
     * carrinhos apareceram com valor que nao batia com o checkout.
     */
    if (!getActiveCartRoot()) {
      var staleRow = summary.querySelector('[data-caleo-progressive-summary-row]');
      if (staleRow) staleRow.remove();
      return;
    }

    var cartTotal = cart && Number.isFinite(Number(cart.total_price)) ? Number(cart.total_price) : NaN;
    // Sem um carrinho recem-buscado do servidor nao ha total confiavel para exibir.
    if (!Number.isFinite(cartTotal)) return;
    summary.dataset.cartTotalCents = String(cartTotal);
    var adjustment = getMiniCartAdjustment(cartTotal);
    var hasDiscount = adjustment.active && adjustment.discountCents > 0;
    var productsTotal = hasDiscount ? adjustment.adjustedProductsCents : cartTotal;
    var shipping = getShippingCents(cartTotal);
    var finalTotal = productsTotal + shipping;
    var discountRow = ensureDiscountRow(summary);
    var discountLabel = discountRow.querySelector('[data-caleo-progressive-summary-label]');
    var discountValue = discountRow.querySelector('[data-caleo-progressive-summary-value]');
    var productsRow = summary.querySelector('[data-mini-cart-products-row]');
    var productsValue = summary.querySelector('[data-mini-cart-products-value]');
    var totalValue = summary.querySelector('[data-mini-cart-total]');
    var pixValue = document.querySelector('[data-mini-cart-pix-value]');
    var installmentValue = document.querySelector('[data-mini-cart-installment-value]');
    setHidden(discountRow, !hasDiscount);
    if (discountLabel) discountLabel.textContent = 'Desconto progressivo';
    if (discountValue) discountValue.textContent = '- ' + formatMoney(adjustment.discountCents);
    if (productsValue) productsValue.textContent = formatMoney(cartTotal);
    if (totalValue) totalValue.textContent = formatMoney(finalTotal);
    if (pixValue) pixValue.textContent = formatMoney(Math.floor(productsTotal * 95 / 100) + shipping);
    if (installmentValue) installmentValue.textContent = formatMoney(Math.round(finalTotal / 10));
    if (productsRow && hasDiscount) setHidden(productsRow, false);
  }

  function ensureMainCartSummary() {
    var summary = document.querySelector('#main-cart-footer .js-contents')
      || document.querySelector('.cart__footer .js-contents');
    if (!summary) return null;
    summary.setAttribute('data-caleo-progressive-main-summary', '');
    var totalRow = summary.querySelector('.totals:not([data-cpd-main-products-row]):not([data-cpd-main-discount-row])');
    if (!totalRow) return summary;
    var totalValue = totalRow.querySelector('.totals__subtotal-value');
    if (totalValue) totalValue.setAttribute('data-cpd-main-total', '');

    if (!summary.querySelector('[data-cpd-main-products-row]')) {
      var productsRow = document.createElement('div');
      productsRow.className = 'totals hidden';
      productsRow.hidden = true;
      productsRow.setAttribute('data-cpd-main-products-row', '');
      productsRow.innerHTML = '<p class="totals__subtotal">Produtos</p><p class="totals__subtotal-value" data-cpd-main-products-value></p>';
      summary.insertBefore(productsRow, totalRow);
    }
    if (!summary.querySelector('[data-cpd-main-discount-row]')) {
      var discountRow = document.createElement('div');
      discountRow.className = 'totals hidden';
      discountRow.hidden = true;
      discountRow.setAttribute('data-cpd-main-discount-row', '');
      discountRow.innerHTML = '<p class="totals__subtotal" data-cpd-main-discount-label>Desconto progressivo</p><p class="totals__subtotal-value" data-cpd-main-discount-value></p>';
      summary.insertBefore(discountRow, totalRow);
    }
    return summary;
  }

  function updateMainCartSummary(cart) {
    // Mesmo criterio do mini-cart: campanha desligada nao mexe no resumo.
    if (!getActiveCartRoot()) return;
    ensureMainCartSummary();
    document.querySelectorAll('[data-caleo-progressive-main-summary]').forEach(function (summary) {
      var cartTotal = cart && Number.isFinite(Number(cart.total_price)) ? Number(cart.total_price) : NaN;
      if (!Number.isFinite(cartTotal)) return;
      summary.dataset.cartTotalCents = String(cartTotal);
      var adjustment = getMiniCartAdjustment(cartTotal);
      var hasDiscount = adjustment.active && adjustment.discountCents > 0;
      setHidden(summary.querySelector('[data-cpd-main-products-row]'), !hasDiscount);
      setHidden(summary.querySelector('[data-cpd-main-discount-row]'), !hasDiscount);
      var productsValue = summary.querySelector('[data-cpd-main-products-value]');
      var discountLabel = summary.querySelector('[data-cpd-main-discount-label]');
      var discountValue = summary.querySelector('[data-cpd-main-discount-value]');
      var totalValue = summary.querySelector('[data-cpd-main-total]');
      if (productsValue) productsValue.textContent = formatMoney(cartTotal);
      if (discountLabel) discountLabel.textContent = 'Desconto progressivo';
      if (discountValue) discountValue.textContent = '- ' + formatMoney(adjustment.discountCents);
      if (totalValue) totalValue.textContent = formatMoney(hasDiscount ? adjustment.adjustedProductsCents : cartTotal);
    });
  }

  function applySummary(cart) {
    updateMiniCartSummary(cart || latestCart);
    updateMainCartSummary(cart || latestCart);
  }

  function findCartItem(cart, line) {
    var items = (cart && cart.items) || [];
    var key = String(line.dataset.lineKey || '');
    var variantId = String(line.dataset.variantId || '');
    for (var index = 0; index < items.length; index += 1) if (key && String(items[index].key || '') === key) return items[index];
    for (var fallback = 0; fallback < items.length; fallback += 1) if (variantId && String(items[fallback].variant_id || items[fallback].id || '') === variantId) return items[fallback];
    return null;
  }

  function clearProgressivePrices(line) {
    if (!line) return;
    line.querySelectorAll('[data-cpd-generated-price]').forEach(function (element) { element.remove(); });
    line.querySelectorAll('.cpd-price-source-hidden').forEach(function (element) { element.classList.remove('cpd-price-source-hidden'); });
    line.querySelectorAll('[data-cpd-line-offer]').forEach(function (element) { element.remove(); });
  }

  function appendProgressivePrice(container, originalCents, discountedCents, kind) {
    if (!container || !Number.isFinite(originalCents) || !Number.isFinite(discountedCents)) return;
    Array.prototype.slice.call(container.children).forEach(function (child) {
      if (child.matches('dl.cart-item__discounted-prices, dd.price, span.price')) child.classList.add('cpd-price-source-hidden');
    });

    var prices = document.createElement('dl');
    prices.className = 'cart-item__discounted-prices cpd-progressive-unit-prices';
    prices.setAttribute('data-cpd-generated-price', kind || 'unit');
    prices.innerHTML = '<dt class="visually-hidden">Preço original</dt>'
      + '<dd class="price--on-sale"><s class="price price-item--regular"><price-money><bdi>' + formatMoney(originalCents) + '</bdi></price-money></s></dd>'
      + '<dt class="visually-hidden">Preço com desconto progressivo</dt>'
      + '<dd class="price"><price-money><bdi>' + formatMoney(discountedCents) + '</bdi></price-money></dd>';
    container.appendChild(prices);
  }

  function renderLinePrice(line, item, data, root) {
    clearProgressivePrices(line);
    if (!line || !item || !data || !isCampaignActive(root) || data.discount <= 0) return;

    var quantity = Math.max(1, parseInt(item.quantity || 1, 10));
    var unitPrice = Number(item.original_price);
    if (!Number.isFinite(unitPrice)) unitPrice = Number(item.price);
    if (!Number.isFinite(unitPrice)) unitPrice = Number(item.final_price);
    if (!Number.isFinite(unitPrice)) return;
    var discountedUnit = Math.floor(unitPrice * (100 - data.discount) / 100);

    var miniContent = line.querySelector('.product-content');
    if (miniContent) appendProgressivePrice(miniContent, unitPrice, discountedUnit, 'unit');

    var desktopUnit = line.querySelector('.cart-item__prices .cart-item__price-wrapper');
    if (desktopUnit) appendProgressivePrice(desktopUnit, unitPrice, discountedUnit, 'unit');

    var originalLine = Number(item.original_line_price);
    if (!Number.isFinite(originalLine)) originalLine = unitPrice * quantity;
    var discountedLine = Math.floor(originalLine * (100 - data.discount) / 100);
    line.querySelectorAll('.cart-item__totals .cart-item__price-wrapper, td.medium-hide.large-up-hide .cart-item__price-wrapper').forEach(function (container) {
      appendProgressivePrice(container, originalLine, discountedLine, 'line');
    });
  }

  function renderLineOffers(cart, root) {
    var data = root && cart ? getEligibleData(cart, root) : null;
    var items = (cart && cart.items) || [];
    document.querySelectorAll('cart-items .mini-cart__navigation > li[data-variant-id]').forEach(function (line, index) {
      renderLinePrice(line, items[index] || findCartItem(cart, line), data, root);
    });
    document.querySelectorAll('cart-items #main-cart-items .cart-item').forEach(function (line, index) {
      renderLinePrice(line, items[index] || findCartItem(cart, line), data, root);
    });
  }

  function getCardProductData(card) {
    var link = card.querySelector('.card-information__text[href*="/products/"]')
      || card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/i);
    var titleNode = card.querySelector('.card-information__text') || link;
    var title = String((titleNode && titleNode.textContent) || '').trim();
    return { handle: match ? decodeURIComponent(match[1]).toLowerCase() : '', title: title };
  }

  function removeCardOffer(card) {
    card.querySelectorAll('[data-cpd-generated-card]').forEach(function (element) { element.remove(); });
  }

  function ensureCardBadgeBox(card) {
    var badgeBox = card.querySelector('.card__badge');
    var sibling = card.nextElementSibling;

    if (!badgeBox && sibling && sibling.classList && sibling.classList.contains('card__badge')) {
      badgeBox = sibling;
      card.appendChild(badgeBox);
    }

    if (!badgeBox) {
      badgeBox = document.createElement('div');
      badgeBox.className = 'card__badge';
      card.appendChild(badgeBox);
    }

    return badgeBox;
  }

  function renderCardOffers(root) {
    var active = !!(root && isCampaignActive(root));
    var steps = active ? getSteps(root) : [];
    var first = steps[0];
    var last = steps[steps.length - 1];
    var excludedTitles = active ? getExcludedTitleSet(root) : {};
    var excludedHandles = active ? getExcludedHandleSet(root) : {};
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var product = getCardProductData(card);
      var excluded = !product;
      if (!active || !first || !last || excluded) { removeCardOffer(card); return; }

      var badgeBox = ensureCardBadgeBox(card);
      if (!badgeBox.querySelector('[data-cpd-generated-card="badge"]')) {
        var badge = document.createElement('span');
        badge.className = 'badge caleo-progressive-card-badge';
        badge.setAttribute('data-cpd-generated-card', 'badge');
        badge.textContent = 'Até ' + last.discount + '% OFF';
        badgeBox.appendChild(badge);
      }

    });
  }

  function refreshTitleBadges() {
    document.querySelectorAll('[data-caleo-progressive-title-badge]').forEach(function (root) {
      setHidden(root, !isCampaignActive(root));
    });
  }

  function scheduleCampaignBoundaryRefresh() {
    clearTimeout(campaignBoundaryTimer);
    var now = Date.now();
    var nextBoundary = null;
    document.querySelectorAll('[data-cpd-version="2"]:not(template)').forEach(function (root) {
      if (!parseBool(root.dataset.enabled)) return;
      var end = parseDate(root.dataset.end || '');
      if (!end || end.getTime() <= now) return;
      if (nextBoundary === null || end.getTime() < nextBoundary) nextBoundary = end.getTime();
    });
    if (nextBoundary === null) return;
    campaignBoundaryTimer = setTimeout(function () {
      campaignBoundaryTimer = null;
      refreshCartRoots(latestCart);
    }, Math.max(50, nextBoundary - now + 50));
  }

  function getProductScope(root) {
    return root.closest('product-info') || root.closest('.product') || document;
  }

  function getSelectedVariantId(root) {
    var scope = getProductScope(root);
    var input = scope.querySelector('form[data-type="add-to-cart-form"] [name="id"]:not([disabled])')
      || scope.querySelector('form[action*="/cart/add"] [name="id"]:not([disabled])')
      || scope.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? String(input.value || '') : String(root.dataset.selectedVariantId || '');
  }

  function getProductQuantity(root) {
    var scope = getProductScope(root);
    var input = scope.querySelector('form[data-type="add-to-cart-form"] [name="quantity"]') || scope.querySelector('[name="quantity"]');
    var quantity = input ? parseInt(input.value || 1, 10) : 1;
    return Math.max(1, Number.isFinite(quantity) ? quantity : 1);
  }

  function getVariants(root) {
    if (root.__cpdVariants) return root.__cpdVariants;
    var script = root.querySelector('[data-caleo-progressive-product-variants]');
    try { root.__cpdVariants = script ? JSON.parse(script.textContent || '[]') : []; }
    catch (error) { root.__cpdVariants = []; }
    return root.__cpdVariants;
  }

  function renderProductRoot(root, cart) {
    var active = isCampaignActive(root);
    setHidden(root, !active);
    if (!active) return;
    var variants = getVariants(root);
    var selectedId = getSelectedVariantId(root);
    var variant = null;
    for (var index = 0; index < variants.length; index += 1) if (String(variants[index].id) === selectedId) { variant = variants[index]; break; }
    var price = variant && typeof variant.price === 'number' ? variant.price : Number(root.dataset.basePriceCents || 0);
    if (Number.isFinite(price) && price > 0) {
      root.dataset.selectedVariantId = selectedId;
      root.dataset.basePriceCents = String(price);
      root.querySelectorAll('[data-cpd-product-step-price]').forEach(function (element) {
        var discount = clamp(Number(element.dataset.discount || 0), 0, 100);
        var suffix = String(element.dataset.suffix || '').trim();
        element.textContent = formatMoney(Math.floor(price * (100 - discount) / 100)) + (suffix ? ' ' + suffix : '');
      });
    }
    var context = root.querySelector('[data-cpd-product-context]');
    if (!context || !cart) return;
    var data = getEligibleData(cart, root);
    var addQuantity = getProductQuantity(root);
    var afterQuantity = data.quantity + addQuantity;
    var currentTier = getTier(data.quantity, data.steps);
    var afterTier = getTier(afterQuantity, data.steps);
    var nextTier = getNextTier(afterQuantity, data.steps);
    if (data.quantity >= data.lastTier.qty) {
      context.innerHTML = 'Seu carrinho já está no desconto máximo de <strong>' + data.lastTier.discount + '% OFF</strong>.';
    } else if (afterTier.discount > currentTier.discount) {
      context.innerHTML = currentTier.discount > 0
        ? 'Seu carrinho está com <strong>' + currentTier.discount + '% OFF</strong>. Ao adicionar este produto, você desbloqueia <strong>' + afterTier.discount + '% OFF</strong>.'
        : 'Ao adicionar ' + (addQuantity === 1 ? 'este produto' : '<strong>' + addQuantity + ' itens</strong> deste produto') + ', você desbloqueia <strong>' + afterTier.discount + '% OFF</strong>.';
    } else if (afterTier.discount > 0 && nextTier) {
      var remaining = Math.max(0, nextTier.qty - afterQuantity);
      context.innerHTML = 'Você mantém <strong>' + afterTier.discount + '% OFF</strong>. Com mais <strong>' + remaining + '</strong> ' + (remaining === 1 ? 'item' : 'itens') + ', chega a <strong>' + nextTier.discount + '% OFF</strong>.';
    }
  }

  function renderProducts(cart) {
    document.querySelectorAll('[data-caleo-progressive-product][data-cpd-version="2"]').forEach(function (root) { renderProductRoot(root, cart || latestCart); });
  }

  /*
   * FAXINA DE RESIDUOS.
   *
   * Roda sempre que o servidor diz que nao ha campanha. Remove da tela tudo o
   * que este script possa ter desenhado - inclusive o que veio dentro de um
   * HTML antigo guardado no cache do navegador, de aba deixada aberta ou
   * restaurada do bfcache (voltar/avancar). E o que garante que a promocao
   * encerrada nao "volte" para nenhum cliente.
   */
  function purgeCampaignArtifacts() {
    var removed = 0;

    // Precos riscados e precos promocionais injetados nas linhas do carrinho,
    // selos "Ate 50% OFF" da vitrine, barras da campanha no mini-cart / /cart /
    // PDP, linhas de "Desconto progressivo" nos resumos e o proprio span de
    // configuracao que sobrou de um HTML antigo.
    document.querySelectorAll([
      '[data-cpd-generated-price]',
      '[data-cpd-line-offer]',
      '[data-cpd-generated-card]',
      '[data-caleo-progressive-summary-row]',
      '[data-cpd-main-products-row]',
      '[data-cpd-main-discount-row]',
      '[data-caleo-progressive-cart]',
      '[data-caleo-progressive-product]',
      '[data-caleo-progressive-title-badge]',
      '[data-caleo-progressive-config]',
      '[data-caleo-progressive-initial-hide]'
    ].join(', ')).forEach(function (element) {
      element.remove();
      removed += 1;
    });

    // Devolve a visibilidade dos precos reais que haviam sido escondidos.
    document.querySelectorAll('.cpd-price-source-hidden').forEach(function (element) {
      element.classList.remove('cpd-price-source-hidden');
      removed += 1;
    });

    // Reexibe a barra original do carrinho.
    document.querySelectorAll('[data-caleo-progressive-original-cart][aria-hidden="true"], [data-caleo-progressive-original-cart].hidden').forEach(function (element) {
      element.hidden = false;
      element.classList.remove('hidden');
      element.removeAttribute('aria-hidden');
      removed += 1;
    });

    if (document.documentElement.classList.contains('caleo-progressive-discount-active')) {
      document.documentElement.classList.remove('caleo-progressive-discount-active');
      removed += 1;
    }

    // So avisa o cart.js quando algo foi realmente removido, para que a limpeza
    // periodica nao fique recalculando o resumo a toa.
    if (removed > 0) document.dispatchEvent(new CustomEvent('mini-cart:shipping-updated'));
    return removed;
  }

  function refreshCartRoots(cart) {
    if (cart) latestCart = cart;
    if (!serverSaysActive()) {
      clearTimeout(campaignBoundaryTimer);
      purgeCampaignArtifacts();
      return;
    }
    var activeCart = cart || latestCart;
    if (activeCart) document.querySelectorAll('[data-caleo-progressive-cart][data-cpd-version="2"]').forEach(function (root) { renderCartRoot(root, activeCart); });
    var configRoot = getActiveConfigRoot();
    renderLineOffers(activeCart, configRoot);
    renderProducts(activeCart);
    refreshTitleBadges();
    renderCardOffers(configRoot);
    applySummary(activeCart);
    scheduleCampaignBoundaryRefresh();
    document.documentElement.classList.toggle('caleo-progressive-discount-active', !!configRoot);
    if (!configRoot) {
      var initialHide = document.querySelector('[data-caleo-progressive-initial-hide]');
      if (initialHide) initialHide.remove();
    }
  }

  function fetchCart() {
    return fetch(CART_URL, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).catch(function () { return null; });
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetchCart().then(function (cart) { if (cart) refreshCartRoots(cart); else { renderProducts(latestCart); applySummary(latestCart); } });
    }, typeof delay === 'number' ? delay : 120);
  }

  function refreshAll() {
    if (!serverSaysActive()) {
      purgeCampaignArtifacts();
      return;
    }
    ensureCampaignSurfaces();
    renderProducts(latestCart);
    refreshTitleBadges();
    renderCardOffers(getActiveConfigRoot());
    scheduleCampaignBoundaryRefresh();
    scheduleRefresh(40);
  }

  window.caleoProgressiveDiscount = {
    refreshAll: refreshAll,
    refreshCart: scheduleRefresh,
    getMiniCartAdjustment: getMiniCartAdjustment,
    applySummary: applySummary,
    formatMoney: formatMoney
  };

  document.addEventListener('DOMContentLoaded', refreshAll);
  /*
   * Paginas restauradas com o botao voltar/avancar (bfcache) reaparecem com o
   * HTML congelado do momento em que foram deixadas. Reavaliar aqui e o que
   * apaga a promocao vencida nesse cenario.
   */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshAll();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !serverSaysActive()) purgeCampaignArtifacts();
  });
  document.addEventListener('change', function (event) {
    if (event.target && (event.target.name === 'id' || event.target.name === 'quantity')) setTimeout(function () { renderProducts(latestCart); }, 40);
  });
  document.addEventListener('variant:change', function () { setTimeout(function () { renderProducts(latestCart); }, 40); });
  document.addEventListener('cartdrawer:opened', function () { scheduleRefresh(60); });
  document.addEventListener('cart:updated', function () { scheduleRefresh(70); setTimeout(function () { scheduleRefresh(0); }, 240); });
  document.addEventListener('cart:refresh', function () { scheduleRefresh(70); });
  document.addEventListener('cart:change', function () { scheduleRefresh(90); });
  document.addEventListener('mini-cart:shipping-updated', function () { setTimeout(function () { applySummary(latestCart); }, 60); });
  document.addEventListener('mini-cart:shipping-cleared', function () { setTimeout(function () { applySummary(latestCart); }, 60); });
  document.addEventListener('shopify:section:load', refreshAll);
  if (document.body && window.MutationObserver) {
    var surfaceTimer = null;
    new MutationObserver(function () {
      clearTimeout(surfaceTimer);
      surfaceTimer = setTimeout(function () {
        var before = document.querySelectorAll('[data-cpd-version="2"]:not(template)').length;
        ensureCampaignSurfaces();
        var after = document.querySelectorAll('[data-cpd-version="2"]:not(template)').length;
        renderCardOffers(getActiveConfigRoot());
        if (after > before && latestCart) refreshCartRoots(latestCart);
      }, 90);
    }).observe(document.body, { childList: true, subtree: true });
  }
  setInterval(function () { refreshCartRoots(latestCart); }, 15000);
  refreshAll();
})();
